import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { DocumentScannerConstants } from '../store/documentScanner.constants'
import { IDocumentScannerState } from '../store/documentScanner.types'
import { getDocumentScannerSelector } from '../selectors/documentScanner.selector'
import { setDisableScanButton, setDocumentAttachments } from '../store/documentScanner.actions'
import { getMaximumDocumentAttachments } from '../store/documentScanner.reducer'

export function* deleteDocumentAttachment() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)
  const { documentAttachments, documentAttachmentToDelete }: IDocumentScannerState = yield select(
    getDocumentScannerSelector
  )

  if (!pcrId || !documentAttachmentToDelete) return

  try {
    const newDocumentAttachments = documentAttachments.filter((documentAttachment) => {
      return documentAttachment.id !== documentAttachmentToDelete
    })
    yield put(setDocumentAttachments(newDocumentAttachments))

    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcrDoc._scannedDocumentAttachments) {
      const newScannedDocumentAttachments = pcrDoc._scannedDocumentAttachments.filter((documentAttachment) => {
        return documentAttachment.id !== documentAttachmentToDelete
      })

      pcrDoc._scannedDocumentAttachments = newScannedDocumentAttachments
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)

      if (newScannedDocumentAttachments.length < getMaximumDocumentAttachments()) {
        yield put(setDisableScanButton(false))
      }
    }
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* deleteDocumentAttachmentSaga() {
  yield takeLatest([DocumentScannerConstants.DELETE_DOCUMENT_ATTACHMENT], performWithMutexHOG, deleteDocumentAttachment)
}
